import { Component, OnInit, ViewChild } from '@angular/core';
import { TfUserDataService } from "@app/modules/tf-user-data";
import { TfPopoverComponent } from '@app/modules/tf-popover/tf-popover/tf-popover.component';
import { PriceService } from "@app/modules/tf-pricing";
import { ProductSiteRegionService } from "@app/services/product-site-region.service";

declare var $: any;

@Component({
    selector: 'tf-price-header',
    templateUrl: 'tf-price-header.component.html',
    styleUrls: ['tf-price-header.component.scss']
})
export class TfPriceHeaderComponent implements OnInit {

    @ViewChild('popOver') popOver: TfPopoverComponent;

    constructor(
        private priceService: PriceService,
        private userDataSrv: TfUserDataService,
        private productSiteRegionService: ProductSiteRegionService
    ) {
    }

    ngOnInit(): void { }

    signIn(){
        if( this.userDataSrv.getIsLoggedInValue() === false){
            if(this.productSiteRegionService.isThermofisher()) {
                this.userDataSrv.login();
            } else if(this.productSiteRegionService.isFisherSci()) {
                // Open modal
                if($) {
                    $.colorbox({
                        href: window.header.login.loginHref,
                        width: "335px",
                        onComplete: function () {
                            // modal deployed
                        }
                    })
                }
            }
        }
    }

    isLoggedIn(): boolean {
        return this.userDataSrv.getIsLoggedInValue();
    }

    showCurrency(): boolean {
        return !(this.getCurrency() === "" || this.getCurrency() === null);
    }

    getCurrency(): string {
        if (this.isLoggedIn()) {
            return this.userDataSrv.getCurrencyCode() != '' ? `${this.userDataSrv.getCurrencyCode()}` : '';
        } else {
            return this.priceService.getAnonymousCurrencyCode() != '' ? `${this.priceService.getAnonymousCurrencyCode()}` : '';
        }
    }

}
